import { App } from 'vue';
import Form from './src/form.vue';

Form.install = (app: App): void => {
    app.component(Form.name, Form);
};

export default Form;

declare module 'vue' {
    export interface GlobalComponents {
        PtForm: typeof Form;
    }
}

export * from './src/token';
